import React, { createContext, useCallback, useState, useContext } from "react";

const ThemeContext = createContext({});

const ThemeProvider = ({ children }) => {
  const [data, setData] = useState({
    sidebar: false,
    currentCategory: null,
  });

  const toogleMenu = useCallback(() => {
    const { sidebar } = data;
    setData({
      ...data,
      sidebar: !sidebar,
    });
  }, [data]);

  const handleCurrentCategory = useCallback(
    (current) => {
      setData({
        ...data,
        currentCategory: Number(current),
      });
    },
    [data]
  );

  return (
    <ThemeContext.Provider
      value={{
        toogleMenu,
        handleCurrentCategory,
        currentCategory: data.currentCategory,
        sidebar: data.sidebar,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

const useTheme = () => {
  const context = useContext(ThemeContext);

  if (!context) {
    throw new Error("useTheme deve ser usado dentro de ThemeContext");
  }

  return context;
};

export { ThemeProvider, useTheme };
